import { of as observableOf, from as observableFrom, Observable } from "rxjs";

import {
  concatMap,
  map,
  switchMap,
  catchError,
  withLatestFrom,
} from "rxjs/operators";
import { Injectable } from "@angular/core";
import { Actions, Effect, ofType } from "@ngrx/effects";
import { KpiService } from "../../kpi/kpi.service";
import {
  GET_METRICS,
  GET_METRICS_ERROR,
  GET_METRICS_SUCCESS,
  SAVE_METRIC_TITLE_DESC,
  SAVE_METRIC_TITLE_DESC_SUCCESS,
  SAVE_METRIC_TITLE_DESC_ERROR,
  GET_SELECTED_METRIC_DATA,
  GET_SELECTED_METRIC_DATA_SUCCESS,
  GET_SELECTED_METRIC_DATA_ERROR,
  UPDATE_METRIC_VISIBILITY,
  UPDATE_METRIC_VISIBILITY_SUCCESS,
  UPDATE_METRIC_VISIBILITY_ERROR,
  SAVE_OTHER_REPORTS_URL,
  SAVE_OTHER_REPORTS_URL_SUCCESS,
  SAVE_OTHER_REPORTS_URL_ERROR,
  GetSelectedMetricDataAction,
  UpdateMetricVisibilityAction,
} from "./actions";
import { Store } from "@ngrx/store";
import { AppState } from "../appState";

@Injectable()
export class MetricEffects {
  constructor(
    private actions$: Actions,
    private kpiService: KpiService,
    private store$: Store<AppState>
  ) {}
  @Effect() getMetrics = this.actions$.pipe(
    ofType(GET_METRICS),
    switchMap((action) =>
      this.kpiService.getMetrics().pipe(
        concatMap((metrics) =>
          observableFrom([{ type: GET_METRICS_SUCCESS, payload: metrics }])
        ),
        catchError(() => observableOf({ type: GET_METRICS_ERROR }))
      )
    )
  );

  @Effect() getSelectedMetricData = this.actions$.pipe(
    ofType(GET_SELECTED_METRIC_DATA),
    map((action: GetSelectedMetricDataAction) => action.payload),
    switchMap((action) =>
      this.kpiService.getSelectedMetricData(action).pipe(
        map((metricData) => ({
          type: GET_SELECTED_METRIC_DATA_SUCCESS,
          payload: metricData,
        })),
        catchError(() => observableOf({ type: GET_SELECTED_METRIC_DATA_ERROR }))
      )
    )
  );

  @Effect() saveMetricTitleDesc = this.actions$.pipe(
    ofType(SAVE_METRIC_TITLE_DESC),
    withLatestFrom(this.store$),
    map(([action, state]) => {
      return {
        kpiId: state.metrics.updatedSelectedMetric.kpi_id,
        name: state.metrics.updatedSelectedMetric.long_name,
        desc: state.metrics.updatedSelectedMetric.definition,
      };
    }),
    switchMap((data) =>
      this.kpiService
        .saveMetricTitleDesc(data.kpiId, data.name, data.desc)
        .pipe(
          map(() => ({ type: SAVE_METRIC_TITLE_DESC_SUCCESS })),
          catchError(() => observableOf({ type: SAVE_METRIC_TITLE_DESC_ERROR }))
        )
    )
  );

  @Effect() saveOtherReportsUrl = this.actions$.pipe(
    ofType(SAVE_OTHER_REPORTS_URL),
    withLatestFrom(this.store$),
    map(([action, state]) => {
      return {
        kpiId: state.metrics.updatedSelectedMetric.kpi_id,
        otherReportsUrl: state.metrics.updatedSelectedMetric.otherReportsUrl,
      };
    }),
    switchMap((data) =>
      this.kpiService
        .saveOtherReportsUrl(data.kpiId, data.otherReportsUrl)
        .pipe(
          map(() => ({ type: SAVE_OTHER_REPORTS_URL_SUCCESS })),
          catchError(() => observableOf({ type: SAVE_OTHER_REPORTS_URL_ERROR }))
        )
    )
  );

  @Effect() updateVisibility = this.actions$.pipe(
    ofType(UPDATE_METRIC_VISIBILITY),
    map((action: UpdateMetricVisibilityAction) => action.payload),
    switchMap((action) =>
      this.kpiService.updateMetricVisibility(action).pipe(
        concatMap((result) =>
          observableFrom([
            {
              type: UPDATE_METRIC_VISIBILITY_SUCCESS,
              payload: result,
            },
          ])
        ),
        catchError(() => observableOf({ type: UPDATE_METRIC_VISIBILITY_ERROR }))
      )
    )
  );
}
